import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';
import useTranslation from '../../../hooks/useTranslation';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const OurWork = (props) => {
  const { classes } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>{t('ourWork')}</h3>
              <p className={classes.aboutUsText}>
                {t('ourWorkText')}
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}our-work`}
              >
                {t('exploreOurWork')}
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}our-work/education`} rel="noopener noreferrer">{t('education')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/food-systems-and-nutrition-evidence-and-gap-map`} rel="noopener noreferrer">{t('foodSystemsEgm')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/mitigating-and-adapting-climate-change`} rel="noopener noreferrer">{t('climateChange')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/research-commissioning-centre-rcc`} rel="noopener noreferrer">{t('rcc')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/rural-india-livelihoods-project`} rel="noopener noreferrer">{t('ruralIndiaLivelihoods')}</a></li>
                  </ul>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.aboutUsRightCol}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}our-work/peacebuilding`} rel="noopener noreferrer">{t('peacebuilding')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/gender-and-womens-empowerment`} rel="noopener noreferrer">{t('genderEmpowerment')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/innovations-data-impact-evaluation`} rel="noopener noreferrer">{t('innovationsData')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/west-africa-capacity-building-and-impact-evaluation`} rel="noopener noreferrer">{t('wacie')}</a></li>
                    <li><a href={`${SITE_LINK}our-work/global-evidence-commitment-advancing-use-rigorous-evidence`} rel="noopener noreferrer">{t('globalEvidenceCommitment')}</a></li>
                  </ul>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

OurWork.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OurWork);
